import { useEffect } from 'react';

import logo from '../../storybook/assets/logo-white.svg';

import { ISimpleHeader } from 'source/NFR.types';

const SimpleHeader: React.FC<ISimpleHeader> = ({ url }) => {
  useEffect(() => {
    // Make space in body to prevent overlap
    const body = document.body;
    if (body) {
      body.classList.add('has-simple-header');
    }

    return () => body && body.classList.remove('has-simple-header');
  }, []);

  return (
    <a href={url} className="simple-header">
      <img className="simple-header__img" alt="Logo" src={logo} />
    </a>
  );
};

SimpleHeader.displayName = 'SimpleHeader';

export default SimpleHeader;
